import React from "react";
import OrderTable from "../Table";

const OrderPickedUp = () => {
  return <OrderTable type="Order Picked Up" />;
};

export default OrderPickedUp;
